'use client';

import { Metadata } from 'next';
import PageContainer from '@/layout/page-container';
import Section from '@/layout/section';
import { PageHero, BulletGrid, Callout } from '@/modules/marketing/components/page-shared';
import { Animated, StaggerContainer } from '@/components/ui/animated';

const rotationTypes = [
  { title: 'Outpatient', text: 'Preceptors work in a private practice/clinic setting. These preceptors mostly work with patients that have scheduled appointments.' },
  { title: 'Inpatient', text: 'Preceptors work in a private hospital/rehabilitation center setting. These preceptors mostly work with emergency or acute care patients.' },
  { title: 'Telehealth', text: 'Many of our preceptors offer online rotations for students interested in a remote learning experience.' },
  { title: 'Inperson', text: 'The preceptors offer on-site experiences where the student will be able to shadow the preceptor directly.' },
];

const specialties = [
  { title: 'Internal Medicine', text: 'Prevention, diagnosis, and treatment of diseases.' },
  { title: 'Family Medicine', text: 'Continuing and comprehensive health care for the individual and family across all ages.' },
  { title: 'Primary Care Services', text: 'for prevention, wellness, and treatment for common illnesses.' },
  { title: 'Pediatrics', text: 'Medical care of infants, children, and adolescents.' },
  { title: 'OB/GYN', text: 'Medical care of pregnancy, childbirth, and the female reproductive system.' },
  { title: 'Acute Care Inpatient', text: 'Treatment for patients who require immediate and intense medical attention.' },
  { title: 'Psychiatry', text: 'Treatment and prevention of mental, emotional and behavioral disorders. (Medication Management)' },
  { title: 'Psychotherapy', text: 'Variety of treatments that aim to help a person identify and change troubling emotions, thoughts, and behaviors.' },
  { title: 'Psychiatry Inpatient', text: 'Treatment for patients that stay overnight in a hospital to get treatment for a mental illness.' },
];

export default function RotationsPage() {
  return (
    <PageContainer>
      <Animated animation="fade-up" duration={800}>
        <PageHero
          kicker="Clinical Placement"
          title="Clinical Rotations"
          subtitle="Curated hands-on, telehealth or hybrid experiences to build competence, expertise, and a strong next generation of Nurse Practitioners!"
        >
          <div className="mt-4 flex gap-3 flex-wrap text-xs text-[var(--brand-muted)]">
            <span className="px-2 py-1 border border-[var(--brand-border)] rounded-md bg-white">Verified Sites</span>
            <span className="px-2 py-1 border border-[var(--brand-border)] rounded-md bg-white">Flexible Scheduling</span>
            <span className="px-2 py-1 border border-[var(--brand-border)] rounded-md bg-white">Expert Assistance</span>
          </div>
        </PageHero>
      </Animated>

      <Section>
        <div className="space-y-14">
          <div className="space-y-6">
            <Animated animation="fade-up" delay={100}>
              <h2 className="text-xl font-semibold tracking-tight">Rotation Formats</h2>
            </Animated>
            <Animated animation="fade-up" delay={200}>
              <BulletGrid items={rotationTypes} cols={3} />
            </Animated>
          </div>
          <div className="space-y-6">
            <Animated animation="fade-up" delay={100}>
              <h2 className="text-xl font-semibold tracking-tight">Common Specialties</h2>
            </Animated>
            <Animated animation="fade-up" delay={200}>
              <BulletGrid items={specialties} cols={3} />
            </Animated>
          </div>
          <Animated animation="fade-up" delay={300}>
            <Callout
              title="Need something not listed?"
              body="Some subspecialties and geographic locations are offered on a specific case basis. Submit a request and our coordination team will confirm availability."
              cta={{ href: '/contact', label: 'Request Availability' }}
            />
          </Animated>
        </div>
      </Section>
    </PageContainer>
  );
}
